import { render } from "./AnswersGiven.vue?vue&type=template&id=222a6c35&scoped=true"
import script from "./AnswersGiven.vue?vue&type=script&lang=js"
export * from "./AnswersGiven.vue?vue&type=script&lang=js"

import "./AnswersGiven.vue?vue&type=style&index=0&id=222a6c35&lang=scss"
import "./AnswersGiven.vue?vue&type=style&index=1&id=222a6c35&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-222a6c35"]])

export default __exports__